import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import React, { useEffect, useState } from 'react'
import { SliderMulti } from "@/components/ui/slider-multi";
import { domesticFilterParams } from '@/src/helpers/domesticFilterItemsHelper';
import { FilterDomesticFlitght } from '@/src/helpers/FilterDomesticFlight';


const DomesticFlightFilter = ({ flightResonse, filteredFlightCallback }) => {
  const [sliderValue, setSliderValue] = useState([0, 0]);
  const [committingMinPrice, setCommittingMinPrice] = useState(0);
  const [committingMaxPrice, setCommittingMaxPrice] = useState(0);
  const [filterParameters, setFilterParameters] = useState(null);
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [filteredFlightsCount, setFilteredFlightsCount] = useState(0);

  const handleChangeFilterCheckbox = (item, isChecked) => {
    if (isChecked) {
      setSelectedAirlines((pre) => [...pre, item]);
    } else {
      setSelectedAirlines((current) =>
        current.filter((selectedAirline) => {
          return selectedAirline !== item;
        })
      );
    }
  };
  useEffect(() => {
    let filterParams = domesticFilterParams(flightResonse);
    setFilterParameters(filterParams);
    if (filterParams?.Airline?.length > 0) {
      var max = filterParams.MaxPrice;
      var min = filterParams.MinPrice;
      setSliderValue([min, max])
      var filteredFlights = FilterDomesticFlitght(flightResonse, filterParams.Airline, min, max);
      setFilteredFlightsCount(filteredFlights.InboundFlights.length + filteredFlights.OutboundFlights.length);
      filteredFlightCallback && filteredFlightCallback(filteredFlights)
    }
  }, [flightResonse])
  useEffect(() => {
    if (filterParameters?.Airline?.length > 0) {
      var filteredFlights = FilterDomesticFlitght(flightResonse, filterParameters.Airline, committingMinPrice, committingMaxPrice)
      setFilteredFlightsCount(filteredFlights.InboundFlights.length + filteredFlights.OutboundFlights.length);
      filteredFlightCallback && filteredFlightCallback(filteredFlights)
    }

  }, [committingMaxPrice, committingMinPrice, selectedAirlines])
  const handleShowAllClick = () => {
    setSelectedAirlines([]);
    setCommittingMinPrice(filterParameters?.MinPrice ?? 0);
    setCommittingMaxPrice(filterParameters?.MaxPrice ?? 0);
    setSliderValue([filterParameters?.MinPrice ?? 0, filterParameters?.MaxPrice ?? 0]);
  };

  return (
    filterParameters && <>
      <div className="p-3 lg:p-0 flex-1 overflow-auto">
        <div className="text-xs">
          <div className="flex items-center justify-between">
            <p>
              <b>{filteredFlightsCount}</b> of <b>{flightResonse?.OutboundFlights?.length + flightResonse?.InboundFlights?.length}</b>{" "}
              flights
            </p>
            <Button variant="link" onClick={handleShowAllClick}>
              <i>Show All</i>
            </Button>
          </div>
          <Accordion type="multiple" className="w-full">
            <AccordionItem value={"item1"}>
              <AccordionTrigger>Airlines</AccordionTrigger>
              {filterParameters.Airline.map((flight, i) => {
                return (
                  <AccordionContent key={flight.Code + "_key" + i}>
                    <div className="flex items-center space-x-2 pb-2">
                      <Checkbox
                        checked={
                          selectedAirlines.filter(
                            (sa) => sa.Code == flight.Code
                          ).length > 0
                        }
                        id={flight.Code}
                        onCheckedChange={(value) => {
                          handleChangeFilterCheckbox(flight, value);
                        }}
                      />
                      <span
                        htmlFor={flight.Code}
                        className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        {flight.Name} ({flight.Code})
                      </span>
                    </div>
                  </AccordionContent>
                );
              })}
            </AccordionItem>
          </Accordion>

          <div>
            <span className="flex flex-1 items-center justify-between py-4 font-medium">
              Price Range
            </span>
            <SliderMulti
              className="SliderRoot"
              defaultValue={[filterParameters.MinPrice, filterParameters.MaxPrice]}
              min={filterParameters.MinPrice}
              max={filterParameters.MaxPrice}
              orientation="horizontal"
              onValueChange={(val) => {
                setSliderValue(val);
              }}
              value={sliderValue}
              onValueCommit={(val) => {
                setCommittingMinPrice(val[0]);
                setCommittingMaxPrice(val[1]);
              }}
              minStepsBetweenThumbs={100}
            ></SliderMulti>
            <div className="flex justify-between pt-4 text-xs">
              <span>{sliderValue[0]}</span>
              <span>{sliderValue[1]}</span>
            </div>
          </div>


        </div>
      </div>
      <div className="flex lg:hidden items-center shadow border-t p-3 gap-x-3 justify-end">
        <Button variant="secondary" className="" onClick={handleShowAllClick}>
          Clear Filter
        </Button>
        <Button className="" onClick={() => {
        }}>Apply</Button>
      </div>
    </>
  )
}

export default DomesticFlightFilter
